import exprEval from 'expr-eval';
import store from '@/store';

const getConfigValue = ({ id, category, parentField }) => {
    const config = store.getters.getMergedConfig;
    const clientInfoRuleId = store.getters.getActiveTab.ClientInfoRuleId;

    if (parentField !== undefined) {
        // returning -1 as a default works for the specific use case of evaluating on number fields, may need to expand how this is done later
        return (
            config[clientInfoRuleId] &&
            config[clientInfoRuleId][category] &&
            config[clientInfoRuleId][category][parentField] &&
            config[clientInfoRuleId][category][parentField][id]
        ) || -1;
    } else {
        return (
            config[clientInfoRuleId] &&
            config[clientInfoRuleId][category] &&
            config[clientInfoRuleId][category][id]
        ) || -1;
    }
}

const evaluateExpression = (expression) => {
    const tokens = expression.split(' ');

    const convertedTokens = tokens.map(token => {
        if (token.startsWith('ConfigField.')) {
            const fieldParts = token.split('.');
            const hasParentField = fieldParts.length === 4;

            const fieldValue = hasParentField ?
                getConfigValue({ id: fieldParts[3], category: fieldParts[1], parentField: fieldParts[2] }) :
                getConfigValue({ id: fieldParts[2], category: fieldParts[1] });
            return fieldValue;
        } else {
            return token;
        }
    });

    const convertedExpression = convertedTokens.join(' ');

    const parser = new exprEval.Parser();
    return parser.evaluate(convertedExpression);
}


export default ({ rules, inputErrorMessage }) => {
    var validationRules = [];
    if (rules && Array.isArray(rules)) {
        for (const valRule of rules) {
            switch (valRule.Type) {
                case "required": {
                    validationRules.push((v) => !(v === undefined || v === '') || (inputErrorMessage || "Field is required"));
                    break;
                }
                case "max": {
                    validationRules.push((v) => (!v || v.length < valRule.Value) || (inputErrorMessage || "Value cannot be more than " + valRule.Value + " characters"));
                    break;
                }
                case "min": {
                    validationRules.push((v) => (!v || v.length > valRule.Value) || (inputErrorMessage || "Value cannot be less than " + valRule.Value + " characters"));
                    break;
                }
                case "greaterThan": {
                    validationRules.push((v) => (!v || Number(v) > Number(valRule.Value)) || (inputErrorMessage || "Value must be greater than " + valRule.Value));
                    break;
                }
                case "greaterThanOrEqualTo": {
                    validationRules.push((v) => (!v || Number(v) >= Number(valRule.Value)) || (inputErrorMessage || "Value must be greater than or equal to " + valRule.Value));
                    break;
                }
                case "lessThan": {
                    validationRules.push((v) => (!v || Number(v) < Number(valRule.Value)) || (inputErrorMessage || "Value must be less than " + valRule.Value));
                    break;
                }
                case "lessThanOrEqualTo": {
                    validationRules.push((v) => (!v || Number(v) <= Number(valRule.Value)) || (inputErrorMessage || "Value must be less than or equal to " + valRule.Value));
                    break;
                }
                case "regex": {
                    const currRegex = new RegExp(valRule.Value);
                    validationRules.push((v) => (!v || currRegex.test(v)) || (inputErrorMessage || "Invalid value"));
                    break;
                }
                case "unique": {
                    validationRules.push((v) => (!v || !valRule.ExistingValues.includes(v)) || (inputErrorMessage || "Duplicate value"));
                    break;
                }
                case "expression": {
                    validationRules.push(() => evaluateExpression(valRule.Value) || (inputErrorMessage || "Invalid value"));
                }
            }
        }
    }
    return validationRules;
}
